export const USER_TIERS_CATALOGUE = '/api/v1/user/tier/catalogue';
export const USER_TIER_SUM = '/api/v1/financial-coordinator/tier/sum';
